(function(APP, $, window, document) {
	'use strict';

	function SliderTestimony(options) {
		if (!(this instanceof SliderTestimony)) return new SliderTestimony(options);

		// On met en place le slider des témoignages
		var $slider = document.querySelector('.js-slider-testimony');
		var $slider_list = $slider.querySelector('.slider__list');
		var $btn_arrow_left = $slider.querySelector('.js-slider-testimony-arrow-left');
		var $btn_arrow_right = $slider.querySelector('.js-slider-testimony-arrow-right');
		var $btn_dots = $slider.querySelectorAll('.js-slider-testimony-dots');
		var dots_list = Array.prototype.slice.call($btn_dots);

		var flkty = new Flickity($slider_list, {
		  cellAlign: 'left',
		  contain: true,
      wrapAround: true,
      draggable: (APP.is.mobile || APP.is.tablet) ? true : false,
			autoPlay: 7000,
      pageDots: false,
      prevNextButtons: false,
			lazyLoad: true,
			on: {
				ready: function() {
					$slider_list.className += ' flickity-is-ready';
				},
			}
		});

    $btn_arrow_left.addEventListener('click', function() {
      flkty.previous();
    }, false);

    $btn_arrow_right.addEventListener('click', function() {
      flkty.next();
    }, false);

    for (var i = 0; i < $btn_dots.length; i++) {

      $btn_dots[i].addEventListener('click', function() {
        flkty.select(dots_list.indexOf(this));
      }, false);
    }

    flkty.on('change', function(test) {

      for (var i = 0; i < $btn_dots.length; i++) {
        $btn_dots[i].classList.remove('is-active');
        if (i === test) {
          $btn_dots[i].classList.add('is-active');
        }
      }
    })

		// On met le lazyLoad pour les logo
		new LazyLoad({
			elements_selector: '.js-testimony-lazyload',
		});

		return this;
	}

	$(window).on('load', function() {
		APP.store.sliderTestimony = new SliderTestimony();
	});

})(APP, jQuery, window, document);
